module.exports = __webpack_public_path__ + "static/media/icon_vungphat.3db2f191.svg";